import { useState, useCallback } from 'react';
import { pdfService } from '../services/pdfService';
import { whatsappService } from '../services/whatsappService';
import { useNotification } from './useNotification';

export const useReservationShare = () => {
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);

    /**
     * Envoyer la réservation via WhatsApp
     */
    const sendViaWhatsApp = useCallback(
        async (reservation, clientName, clientPhone, isAdmin = false) => {
            try {

                setLoading(true);

                // Créer le message
                const message = whatsappService.createReservationMessage(
                    reservation,
                    clientName
                );


                // Ouvrir WhatsApp
                whatsappService.openWhatsApp(clientPhone, message);

                showNotification('WhatsApp ouvert avec le message', 'success');

            } catch (error) {
                console.error('[useReservationShare] Erreur:', error);
                showNotification(`Erreur: ${error.message}`, 'error');
            } finally {
                setLoading(false);
            }
        },
        [showNotification]
    );

    /**
     * Générer et télécharger le PDF
     */
    const downloadPDF = useCallback(async (elementId, fileName) => {
        try {

            setLoading(true);

            // Attendre un peu pour que le DOM soit prêt
            await new Promise(resolve => setTimeout(resolve, 500));

            const pdf = await pdfService.generatePDFFromHTML(elementId, fileName);
            pdfService.downloadPDF(pdf, fileName);

            showNotification('PDF téléchargé avec succès', 'success');

        } catch (error) {
            console.error('[useReservationShare] Erreur:', error);
            showNotification(`Erreur PDF: ${error.message}`, 'error');
        } finally {
            setLoading(false);
        }
    }, [showNotification]);

    /**
     * Envoyer le PDF via WhatsApp (avec lien ou description)
     */
    const sendPDFViaWhatsApp = useCallback(
        async (reservation, clientName, clientPhone) => {
            try {

                setLoading(true);

                // Créer un message avec les détails
                const message = `
*OV HAIRSTYLE - Confirmation de Réservation*

👤 Client: ${clientName}
📋 ID: ${reservation.id}
💇 Service: ${reservation.serviceName}
📅 Date: ${new Date(reservation.date).toLocaleDateString('fr-FR')}
🕐 Heure: ${reservation.time}
💰 Prix: ${reservation.price}€

Veuillez télécharger votre confirmation en PDF depuis votre profil.

Merci!
        `.trim();

                whatsappService.openWhatsApp(clientPhone, message);

                showNotification('Message envoyé via WhatsApp', 'success');
            } catch (error) {
                console.error('[useReservationShare] Erreur:', error);
                showNotification(`Erreur: ${error.message}`, 'error');
            } finally {
                setLoading(false);
            }
        },
        [showNotification]
    );

    return {
        sendViaWhatsApp,
        downloadPDF,
        sendPDFViaWhatsApp,
        loading,
    };
};
